import React, { useEffect, useState, useRef } from "react";
import {
    getBulkDropdownData,
    getOtherRefSearchDropdown,
} from "../../../api/keyvalue";
import SearchDropdown from "../../input/SearchDropdown";
import LoadingSpinner from "../../LoadingSpinner";
import Button from "../../input/Button";
import Dropdown from "../../input/Dropdown";
import Input from "../../input/Input";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { vehicleAssignmentSearch } from "../../../api/jobApi";

const RevenueDistributionSearch = ({
                                       searchResHandler,
                                       resetHandler,
                                       reportType,
                                       dateType,
                                       setReportType,
                                       setDateType
                                   }) => {
    const userData = useSelector((state) => state.user.userDetails);
    const user = useSelector((state) => state.user);

    const [reportTypeOptions, setReportTypeOptions] = useState([]);
    const [dateTypeData, setDateTypeData] = useState([]);
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [transporter, setTransporter] = useState("");

    const [resetSearchFields, setResetSearchFields] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [reloadDates, setReloadDates] = useState(true);
    const [vehicle, setVehicle] = useState("");
    const [transporterValue, setTransporterValue] = useState("");
    const [vehicleValue, setVehicleValue] = useState("");
    const vehicleRef = useRef();

    useEffect(() => {
        (async () => {
            setIsLoading(true);
            const {
                rev_dis_report_type: reportTypeData = [],
                date_types: dateTypeData = [],
            } = await getBulkDropdownData([
                { key: "rev_dis_report_type" },
                { key: "date_types" },
            ]);
            setReportTypeOptions(reportTypeData);
            setDateTypeData(dateTypeData);
            setIsLoading(false);
        })();
    }, []);

    useEffect(() => {
        if (reloadDates) {
            const aWeekAgo = new Date();
            aWeekAgo.setDate(aWeekAgo.getDate() - 7);
            const formattedWeekAgo = aWeekAgo.toISOString().split("T")[0];
            const formattedToday = new Date().toISOString().split("T")[0];
            setFromDate(formattedWeekAgo);
            setToDate(formattedToday);
        }
        setReloadDates(false);
    }, [reloadDates]);

    const onSearch = (e) => {
        e.preventDefault();
        if (!reportType || !fromDate || !toDate) {
            toast.warn("distribution type and date type are mandatory", {
                autoClose: 5000,
                containerId: "Main",
            });
            return;
        }

        searchResHandler({
            reportType,
            dateType,
            fromDate: getValueOrDefault(fromDate),
            toDate: getValueOrDefault(toDate),
            transporter: getValueOrDefault(transporter),
            vehicleNos: getValueOrDefault(vehicle),
        });
    };

    function getValueOrDefault(value, defaultValue = "-2") {
        if (Array.isArray(value)) {
            return value.length > 0 ? value.join(",") : defaultValue;
        }
        return value && value.toString().trim() !== ""
            ? value.toString()
            : defaultValue;
    }

    const onReset = (e) => {
        e.preventDefault();
        setResetSearchFields(true);
        setReportType(1);
        setDateType(1);
        setTransporter(null);
        setTransporterValue("");
        setVehicle("");
        setVehicleValue("");
        setReloadDates(true);
        resetHandler();

        setTimeout(() => setResetSearchFields(false), 0);
    };

    return (
        <>
            {isLoading ? (
                <LoadingSpinner />
            ) : (
                <form className="ui form">
                    <h4 className="ui dividing header">Information</h4>
                    <div className="three fields" style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                        <div className="field">
                            <Dropdown
                                required
                                options={dateTypeData}
                                label="Date Type"
                                placeholder="Date Type"
                                style={{ height: "20px" }}
                                value={dateType}
                                onChange={(e, data) => setDateType(data.value)}
                                clearable={false}
                            />
                        </div>
                        <div className="field">
                            <Input
                                required
                                type="date"
                                label="From Date"
                                name="fromDate"
                                max={toDate ?? new Date().toISOString().split("T")[0]}
                                value={fromDate}
                                onChange={(e) => setFromDate(e.target.value)}
                            />
                        </div>
                        <div className="field">
                            <Input
                                required
                                label="To Date"
                                type="date"
                                name="toDate"
                                min={fromDate}
                                value={toDate}
                                disabled={!fromDate}
                                onChange={(e) => setToDate(e.target.value)}
                            />
                        </div>
                    </div>

                    <div className="three fields" style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                        <div className="field">
                            <Dropdown
                                required
                                options={reportTypeOptions}
                                label="Revenue Distribution Type"
                                placeholder="Revenue Distribution Type"
                                style={{ height: "20px" }}
                                value={reportType}
                                onChange={(e, data) => setReportType(data.value)}
                                clearable={false}
                            />
                        </div>
                        <div className="field">
                            <SearchDropdown
                                key="vehicle"
                                ref={vehicleRef}
                                clearable={true}
                                reset={resetSearchFields}
                                setReset={setResetSearchFields}
                                returnFullObject={true}
                                module={"Reports"}
                                form={"Revenue Distribution"}
                                label="Vehicle"
                                placeholder="Select Vehicle"
                                field="vehicle"
                                multiGrid={true}
                                multiGridCurrentValue={vehicleValue}
                                onClear={() => {
                                    setVehicle("");
                                    setVehicleValue("");
                                }}
                                onResultSelect={(data) => {
                                    setVehicle(data.value);
                                    setVehicleValue(data.text);
                                    if (!transporter) {
                                        setTransporter(data.transId || "");
                                        setTransporterValue(data.transporterName || "");
                                    }
                                }}
                                api={vehicleAssignmentSearch}
                                apiDependency={{
                                    lTransporter: transporter || null,
                                    lVehicleType: null,
                                    cbm: -2,
                                    lCommit: 2,
                                    fullObject: true,
                                }}
                                fieldInfo={{
                                    tableName: "masterdata.tms_m_vehicle_details",
                                    primaryKey: "veh_id",
                                    fieldName: "veh_vehicleno",
                                    ids: vehicle,
                                }}
                            />
                        </div>

                        <div className="field">
                            <SearchDropdown
                                key="transporter"
                                reset={resetSearchFields}
                                setReset={setResetSearchFields}
                                clearable={true}
                                module={"Reports"}
                                form={"Revenue Distribution"}
                                label="Transporter"
                                placeholder="Select Transporter"
                                field="transporter"
                                multiGrid={true}
                                multiGridCurrentValue={transporterValue}
                                onResultSelect={(data) => {
                                    setTransporter(data);
                                    setTransporterValue("");
                                    setVehicle("");
                                    setVehicleValue("");
                                    vehicleRef.current?.reset();
                                }}
                                onClear={() => {
                                    setTransporter("");
                                    setTransporterValue("");
                                    setVehicle("");
                                    setVehicleValue("");
                                    vehicleRef.current?.reset();
                                }}
                                api={getOtherRefSearchDropdown}
                                apiDependency={{
                                    type: "stakeholder_type",
                                    value: "Transporter",
                                }}
                                fieldInfo={{
                                    tableName: "masterdata.tms_m_statkeholder",
                                    primaryKey: "stk_id",
                                    fieldName: "stk_name",
                                    ids: transporter,
                                }}
                            />
                        </div>

                    </div>

                    <div style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "flex-end" }}>
                        <div className="field" style={{ width: "100%" }}>
                            <Button template="search" onClick={onSearch} />
                            <Button template="searchReset" onClick={onReset} />
                        </div>
                    </div>
                </form>
            )}
        </>
    );
};

export default RevenueDistributionSearch;

